import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import useSpectrum from '../../hooks/useSpectrum';
import Left1DChart from '../1d-tracer/Left1DChart';
import Top1DChart from '../1d-tracer/Top1DChart';
import Contours from './Contours';
export function FTContainer(props) {
    const { spectra } = props;
    const activeSpectrum = useSpectrum();
    if (activeSpectrum?.info?.isFid) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [spectra?.[0] && _jsx(Top1DChart, { data: spectra[0] }), spectra?.[1] && _jsx(Left1DChart, { data: spectra[1] }), _jsx(Contours, {})] }));
}
